import React from 'react';
import { BrowserRouter as Router, Navigate, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import SuperadminDashboard from './pages/SuperadminDashboard';
import DynamicKriteriaFormPage from './pages/DynamicKriteriaFormPage';
import ArsipGlobal from './pages/ArsipGlobal';
import SettingsPage from './pages/SettingsPage';
import AccountSettingsPage from './pages/AccountSettingsPage';
import UserManagementPage from './pages/UserManagementPage';
import SystemSettingsPage from './pages/SystemSettingsPage';
import KriteriaManagementPage from './pages/KriteriaManagementPage';
import LaporanPage from './pages/LaporanPage';
import BantuanPage from './pages/BantuanPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/superadmin" element={<SuperadminDashboard />} />
        <Route path="/c1" element={<Navigate to="/kriteria/c1" replace />} />
        <Route path="/c1/:section" element={<Navigate to="/kriteria/c1" replace />} />
        <Route path="/c2" element={<Navigate to="/kriteria/c2" replace />} />
        <Route path="/c3" element={<Navigate to="/kriteria/c3" replace />} />
        <Route path="/c4" element={<Navigate to="/kriteria/c4" replace />} />
        <Route path="/c5" element={<Navigate to="/kriteria/c5" replace />} />
        <Route path="/c6" element={<Navigate to="/kriteria/c6" replace />} />
        <Route path="/c7" element={<Navigate to="/kriteria/c7" replace />} />
        <Route path="/kriteria/:kode" element={<DynamicKriteriaFormPage />} />
        <Route path="/arsip" element={<ArsipGlobal />} />
        <Route path="/laporan" element={<LaporanPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/settings/account" element={<AccountSettingsPage />} />
        <Route path="/settings/users" element={<UserManagementPage />} />
        <Route path="/settings/system" element={<SystemSettingsPage />} />
        <Route path="/settings/kriteria" element={<KriteriaManagementPage />} />
        <Route path="/bantuan" element={<BantuanPage />} />
        <Route path="/preview-arsip-c3" element={<Navigate to="/arsip" replace />} />
        <Route path="/arsip-c3" element={<Navigate to="/arsip" replace />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
